<div>
  <ion-card color="warning">
    <ion-fab vertical="top" horizontal="end">
      <ion-fab-button color="danger" size="small">
        <ion-icon name="alert-sharp"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-card-header>
      <ion-card-title>{{'PUZZLE.desktop_mode_warning.title'|translate}}</ion-card-title>
    </ion-card-header>
    <ion-card-content>{{'PUZZLE.desktop_mode_warning.text'|translate}}</ion-card-content>
  </ion-card>
</div>
